import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { GridComponent } from '../grid.component';


export interface CliccableActionItems<T> {
  action: 'details' | 'copy' | 'generate-labels' | 'delete'; 
  data: T;
}

export interface ItemGridClickableConfig {
  showEdit?: boolean;
  showCopy?: boolean;
  showLabels?: boolean;
  showDelete?: boolean;
  showDetails?: boolean;
}

@Component({
  selector: 'app-grid-clickable-button-items',
  standalone: true,
  imports: [
    MatIcon,
    MatMenuModule,
    MatButtonModule,
    TranslateModule
  ],
  templateUrl: './grid-clickable-button-items.component.html',
  styleUrl: './grid-clickable-button-items.component.scss'
})
export class GridClickableButtonItemsComponent implements ICellRendererAngularComp {

    protected showEdit = false;
    protected showCopy = false;
    protected showLabels = false;
    protected showDelete = false;

    _params!: ICellRendererParams;

    get params() {
        return this._params;
    }

    set params(v) {
        this._params = v;
    }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;

    const config: ItemGridClickableConfig = (params as any).showEdit !== undefined
      ? (params as any) 
      : params.colDef?.cellRendererParams;

    if (config) {
      this.showEdit = config.showEdit ?? false;
      this.showCopy = config.showCopy ?? false;
      this.showLabels = config.showLabels ?? false;
      this.showDelete = config.showDelete ?? false;
    }
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  preventSelection($event: MouseEvent) {
    $event.stopPropagation();
  }

  editItem($event: any) {
    (<GridComponent>this.params.context.componentParent).clickableAction.emit({
        action: 'details',
        data: this.params.data
    });
  }

  copyItem($event: any) {
    (<GridComponent>this.params.context.componentParent).clickableAction.emit({
        action: 'copy',
        data: this.params.data
    });
  }

  generateLabelsItem($event: any) {
    (<GridComponent>this.params.context.componentParent).clickableAction.emit({
        action: 'generate-labels',
        data: this.params.data
    });
  }

  onRemoveSelected($event?: any) {
    (<GridComponent>this.params.context.componentParent).clickableAction.emit({
      action: 'delete',
      data: this.params.data
    });
  }

}
